import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import some from 'lodash/some';

export const selectLockRequiresCheck = createSelector(({ rowLock }) => rowLock?.requiresCheck, result => result);

export const selectLocked = createSelector(({ rowLock }) => rowLock?.locked, result => result);

export const selectLockedBy = createSelector(({ rowLock }) => rowLock?.lockedByUserName, result => result);

export const selectLockedByMe = createSelector(({ rowLock }) => rowLock?.lockedByMe, result => result);

export const selectImpersonatedBy = createSelector(({ rowLock }) => rowLock?.impersonatedByUserName, result => result);

export const selectLastUpdatedOn = createSelector(({ rowLock }) => rowLock?.lastUpdatedOn, result => result);

export const selectLastCheckedOn = createSelector(({ rowLock }) => rowLock?.lastCheckedOn, result => result);

export const selectEntity = createSelector(({ rowLock }) => rowLock?.entity, result => result);

export const selectCreatedLocks = createSelector(({ rowLock }) => rowLock?.createdLocks, result => result);

export const selectCreatedWithinSession = createSelector(selectEntity, selectCreatedLocks, (entity, createdLocks) => {
  if (isEmpty(entity)) return false;
  if (isEmpty(createdLocks)) return false;
  return some(createdLocks, lockedEntity => isEqual(lockedEntity, entity));
});

export const selectError = createSelector(({ rowLock }) => rowLock?.error, result => result);

export const selectClareityUrl = createSelector(({ rowLock }) => rowLock?.clareityUrl, result => result);

export const selectCallback = createSelector(({ rowLock }) => rowLock?.callback, result => result);

export const selectLoading = createSelector(({ rowLock }) => rowLock?.loading, result => result);
